import { setupIonicReact } from '@ionic/react';

// NOTE: This overrides platform checking logic for Ionic, it must be the first imported line in index.tsx in order to set the config before the configuration is used in the rendered app.
setupIonicReact({
  platform: {
    /* Declaring explicitly the platforms we support in mobile mode to simplify logic
     * derived from the platform checks. This accounts for a particular "defect"
     * in Ionic, where touch screen laptops are identified as "mobile" with the
     * original declaration.
     */
    mobile: win => {
      console.log('Testing mobile user agent: ', win.navigator.userAgent);
      return /Android|iPhone|iPad|iPod/i.test(win.navigator.userAgent);
    },
  },
});
